import keymirror from 'keymirror';

const layoutMap = keymirror({
  vertical: null,
  horizontal: null,
});

export const layoutTypeList = Object.keys(layoutMap);

export default layoutMap;
